import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: 36,
    background: '#F5F8FA',
    border: 'none',
    borderRadius: '5px',
    boxShadow: 'none',
    color: '#004987',
    height: '102px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      height: '162px',
    },
  },
  active: {
    background: '#FFFFFF',
    boxShadow:
      '0px 11px 55px rgba(0, 0, 0, 0.07), 0px 13px 18px rgba(0, 0, 0, 0.15)',
    border: '1px solid rgba(43, 41, 45, 0.35)',
    color: '#000',
  },
}));

export default function AddressSelectBox({
  active,
  setActive,
  children,
  ...props
}) {
  const classes = useStyles();
  return (
    <Box
      width='100%'
      boxShadow={1}
      className={`${classes.root} ${active && classes.active}`}
      onClick={setActive}
      {...props}>
      {children}
    </Box>
  );
}
